import { render } from "./treeProduct.vue?vue&type=template&id=68a1853c"
import script from "./treeProduct.vue?vue&type=script&lang=js"
export * from "./treeProduct.vue?vue&type=script&lang=js"

import "./treeProduct.vue?vue&type=style&index=0&id=68a1853c&lang=css"

import exportComponent from "/var/www/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__